import { useWorkflowSession } from '../../contexts/WorkflowSessionContext';
import { RootDocument } from '../../types';

export function useRootDocument<T = RootDocument>(): T | undefined {
  const { rootDocument } = useWorkflowSession();

  return rootDocument as T | undefined;
}
